
import { useEffect, useState } from "react";
import { Card } from "@material-ui/core";
import { Button, DialogActions, Grid, MenuItem, TextField } from "@mui/material";
import api from "../../services/api";
import LoadingBackdrop from "../../load/loadingBackdrop";
import { useSelector } from "react-redux";
import RegisterAccess from "../../utils/registerAccess";
import AlertEdit from "../../utils/alertEdit";

export default function DirectorTecnicoEdit({ dadosDirectorTecnico, cancelEditDados, setDadosDirectorTecnico, setMessageSuccess, setMessageError, setRefresh }) {
    const [editDados, setEditDados] = useState('')
    const [open, setOpen] = useState(false);
    const user = useSelector(state => state.account.user);
    const [categoria, setCategoria] = useState([]);


    useEffect(() => {
        api.get('/categoria-tecnico')
            .then(res => {
                setCategoria(res.data.categoriaTecnicos);
            })
            .catch(err => '')
    }, [])

    function HandleChange(e) {
        setEditDados((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    }

    const submitEdit = async () => {

        setOpen(true)
        setMessageSuccess('')
        setMessageError('')

        await api.put('/director-tecnico/edit', { ...editDados, 'directorTecnicoId': dadosDirectorTecnico._id, 'userId': user?._id ?? '' })
            .then(res => {
                setDadosDirectorTecnico(res.data.directorTecnico)
                setRefresh(res.data.directorTecnico)
                setOpen(false)
                setMessageSuccess(res.data.msg)
                cancelEditDados(false)

            }).catch(err => {
                // console.log(err)
                setOpen(false)
                setMessageError(err.response.data.message)
            })
    }

    return (
        <>
            <RegisterAccess page={'editar dados director tecnico'} />
            <LoadingBackdrop open={open} />

            <Card style={{ border: '1px solid orange' }}>

                <AlertEdit />

                <Grid container>
                    <Grid xs={12} md item m>
                        <TextField
                            type="number"
                            required
                            label="Carteira"
                            fullWidth
                            size="small"
                            name="numeroCarteira"
                            variant="outlined"
                            onChange={HandleChange}
                            defaultValue={dadosDirectorTecnico?.numeroCarteira}
                        />
                    </Grid>

                    <Grid xs={12} md item m>
                        <TextField
                            required
                            type="text"
                            label="Categoria"
                            select
                            fullWidth
                            size="small"
                            name="categoriaId"
                            variant="outlined"
                            onChange={HandleChange}
                            defaultValue={dadosDirectorTecnico?.categoria?._id ?? ''}
                        >
                            <MenuItem disabled value=''>Selecione Categoria</MenuItem>
                            {categoria?.map((categoria) => (
                                <MenuItem key={categoria._id} value={categoria._id}>
                                    {categoria.designacao}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid xs={12} md item m>
                        <TextField
                            type="text"
                            label="Ordem"
                            fullWidth
                            size="small"
                            name="ordem"
                            variant="outlined"
                            onChange={HandleChange}
                            defaultValue={dadosDirectorTecnico?.ordem}
                        />
                    </Grid>
                </Grid>

                <DialogActions >
                    <Button onClick={() => { cancelEditDados(false) }} color="warning" size="small" style={{ marginTop: 20, marginRight: 10 }}>Cancelar</Button>
                    <Button variant="contained" onClick={() => { submitEdit() }} size="small" style={{ marginTop: 20, background: '#85287e' }}>Salvar</Button>
                </DialogActions>
            </Card>
        </>
    )
}